import React from 'react';
interface TestimonialsWaveDividerProps {
  topColor?: string;
  bottomColor?: string;
}
export function TestimonialsWaveDivider({
  topColor = '#f5f1ed',
  bottomColor = '#2d4a3a'
}: TestimonialsWaveDividerProps) {
  return <div className="relative w-full overflow-hidden" style={{
    backgroundColor: topColor
  }} data-id="element-541">
      

      <style data-id="element-542">{`
        @keyframes testimonialsWave {
          0%, 100% {
            transform: translateX(0) scaleY(1);
          }
          50% {
            transform: translateX(-25px) scaleY(1.05);
          }
        }
        
        @media (prefers-reduced-motion: reduce) {
          svg path {
            animation: none !important;
          }
        }
      `}</style>
    </div>;
}